/**
 * dashboard-time-window.ts
 *
 * Pure time-window computation for the Leasing Dashboard's activity filter.
 * Kept dependency-free (no component imports) so it can be unit tested
 * without pulling in browser-only providers (Centrifugo, Firebase messaging).
 */

export type ActivityTimeWindow = '1h' | '4h' | 'today';

export function computeSince(w: ActivityTimeWindow): string {
  const now = new Date();
  if (w === '1h') return new Date(now.getTime() - 60 * 60 * 1000).toISOString();
  if (w === '4h') return new Date(now.getTime() - 4 * 60 * 60 * 1000).toISOString();
  // 'today' → start of today in the viewer's local timezone (this is a
  // cross-property aggregate view, so there is no single property timezone
  // to anchor on — see docs/claude/timezone-policy.md Rule 3).
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return today.toISOString();
}
